import React, { useState } from 'react';
import axios from 'axios';
import { validarCedulaUruguaya } from '../helpers/ciUtils';

const MAX_FILE_SIZE = 3 * 1024 * 1024;
const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const API_URL = process.env.REACT_APP_API_URL || '/api';

const EscolaridadPage = () => {
  const [cedula, setCedula] = useState('');
  const [documento, setDocumento] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setError('');
    setSuccess(false);

    if (!file) {
      setDocumento(null);
      return;
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      setDocumento(null);
      event.target.value = '';
      setError('El archivo debe ser PDF, JPG o PNG.');
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setDocumento(null);
      event.target.value = '';
      setError('El archivo no puede superar los 3 MB.');
      return;
    }

    setDocumento(file);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);

    if (!validarCedulaUruguaya(cedula)) {
      setError('Ingresá una cédula uruguaya válida, sin puntos ni guiones.');
      return;
    }

    if (!documento) {
      setError('Seleccioná el documento de escolaridad.');
      return;
    }

    const formData = new FormData();
    formData.append('cedula', cedula);
    formData.append('documento', documento);

    try {
      setSubmitting(true);
      await axios.post(`${API_URL}/form/escolaridad`, formData);
      setSuccess(true);
      setCedula('');
      setDocumento(null);
      event.target.reset();
    } catch (requestError) {
      console.error(requestError);
      setError(requestError.response?.data?.error || 'No pudimos cargar la escolaridad. Intentá nuevamente.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="school-upload-page">
      <section className="school-upload-card">
        <h1>Cargá tu escolaridad</h1>
        <p className="school-upload-intro">
          Ingresá la cédula con la que realizaste tu postulación y adjuntá un único documento.
        </p>

        {success ? (
          <div className="school-upload-success" role="status">
            <h2>Documento recibido</h2>
            <p>Tu escolaridad quedó asociada correctamente a tu postulación.</p>
            <button type="button" className="btn btn-primary" onClick={() => setSuccess(false)}>
              Cargar otro documento
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="school-upload-field">
              <label htmlFor="cedula">Cédula</label>
              <input
                id="cedula"
                className="form-control"
                type="text"
                inputMode="numeric"
                autoComplete="off"
                placeholder="Sin puntos ni guiones"
                value={cedula}
                maxLength={8}
                onChange={(event) => setCedula(event.target.value.replace(/\D/g, ''))}
                disabled={submitting}
                required
              />
            </div>

            <div className="school-upload-field">
              <label htmlFor="documento">Documento de escolaridad</label>
              <input
                id="documento"
                className="form-control school-upload-file"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                onChange={handleFileChange}
                disabled={submitting}
                required
              />
              <small>PDF, JPG o PNG. Tamaño máximo: 3 MB.</small>
            </div>

            {error && <div className="school-upload-error" role="alert">{error}</div>}

            <button type="submit" className="btn btn-primary school-upload-submit" disabled={submitting}>
              {submitting ? 'Cargando…' : 'Cargar documento'}
            </button>
          </form>
        )}
      </section>
    </main>
  );
};

export default EscolaridadPage;
